export const PROVIDER_STATUS = ['Active', 'Inactive', 'Suspended', 'Pending'];
export const PROVIDER_ACCREDITATION_STATUS = ['Active', 'Suspended', 'Pending', 'Expired', 'Revoked'];
export const COURSE_STATUS = ['Active', 'Archived', 'PendingAccreditation'];
export const DELIVERY_MODE = ['Classroom', 'Online', 'Blended', 'InCompany'];
export const INDUSTRY_SECTORS = ['Mining', 'Manufacturing', 'Construction', 'Finance', 'Healthcare', 'Retail', 'Agriculture', 'Transport', 'Education', 'Government'];

export const STATUS_COLORS_PROVIDER: Record<string, string> = {
  Active: 'success',
  Inactive: 'default',
  Suspended: 'warning',
  Pending: 'info',
  Expired: 'error',
  Revoked: 'error',
};

export const STATUS_COLORS_COURSE: Record<string, string> = {
  Active: 'success',
  Archived: 'default',
  PendingAccreditation: 'warning',
};

export const PROVINCE_CHOICES = [
  { id: 'Eastern Cape', name: 'Eastern Cape' },
  { id: 'Free State', name: 'Free State' },
  { id: 'Gauteng', name: 'Gauteng' },
  { id: 'KwaZulu-Natal', name: 'KwaZulu-Natal' },
  { id: 'Limpopo', name: 'Limpopo' },
  { id: 'Mpumalanga', name: 'Mpumalanga' },
  { id: 'Northern Cape', name: 'Northern Cape' },
  { id: 'North West', name: 'North West' },
  { id: 'Western Cape', name: 'Western Cape' },
];

export const ACCREDITATION_CHOICES = PROVIDER_ACCREDITATION_STATUS.map(s => ({ id: s, name: s }));
export const STATUS_CHOICES = PROVIDER_STATUS.map(s => ({ id: s, name: s }));
